module.exports = __webpack_public_path__ + "media/time.3d0c7ed2.mp3";